import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';

import colors from '../../../../styles/colors';

const PreviewText = styled(Typography)({
  whiteSpace: 'pre-wrap',
  color: colors.shades.beta2,
  lineHeight: 1.5,
});

PreviewText.defaultProps = { variant: 'body2' };

export default PreviewText;
